module.exports = __webpack_public_path__ + "media/audio2.1cbb7037.wav";